import { LANGUAGES } from "../../common/constants";

export enum ThemeActions {
  SET_THEME = "SET_THEME",
  SET_LANGUAGE = "SET_LANGUAGE",
}

export interface ISetTheme {
  type: ThemeActions.SET_THEME;
  mode: "dark" | "light";
}

export interface ISetLanguage {
  type: ThemeActions.SET_LANGUAGE;
  language: LANGUAGES;
}

export function setTheme(mode: "dark" | "light"): ISetTheme {
  return {
    type: ThemeActions.SET_THEME,
    mode,
  };
}

export function setLanguage(language: LANGUAGES): ISetLanguage {
  return {
    type: ThemeActions.SET_LANGUAGE,
    language,
  };
}

export type ThemeAction = ISetTheme | ISetLanguage;
